import { render, staticRenderFns } from "./hero.vue?vue&type=template&id=4af16b1e&scoped=true&"
import script from "./hero.vue?vue&type=script&lang=js&"
export * from "./hero.vue?vue&type=script&lang=js&"
import style0 from "./hero.vue?vue&type=style&index=0&id=4af16b1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af16b1e",
  null
  
)

export default component.exports